/**
 * Coups de pouce — Attendu 1044 « Additionner et soustraire des décimaux :
 * 2,7 + 1,4 ; 3,4 − 0,8 » (automatisme 5e).
 *
 * Doctrine exemple modélisant : pas de règle, le déroulé fait le geste, en
 * langue d'élève, par le chemin de la NUMÉRATION (« 27 dixièmes », le
 * cadrage prof 2026-08-31). Tout vit sur la PAIRE SACRIFIÉE 2,7 + 1,4 et sa
 * soustraction liée 4,1 − 1,4 (cf. PAIRE_SACRIFIEE dans gen_1044 : aucune de
 * ces opérations ne sort en tirage, F3 compris) : invariant protégé par
 * cdp1044.self.test.js.
 * PAS d'entrée pour verif_inverse_saisie (l'aide dirait la réponse : refaire
 * l'opération inverse EST tout le travail) : Tano sert son conseil générique.
 * Le DÉFI a sa fiche en CENTIÈMES, même squelette, sur sa propre paire
 * sacrifiée 3,45 + 1,2 (cf. PAIRE_SACRIFIEE_DEFI dans gen_1044).
 * Les explications post-réponse spécifiques à l'item vivent dans
 * contenu.explications du gen (« 2,7 c'est 27 dixièmes, plus 14 dixièmes… »).
 */

// Deux pages symétriques (version prof 2026-08-31) : la retenue et l'emprunt
// ne sont jamais nommés (ils se font tout seuls dans le calcul entier, ce qui
// désarme le « séparateur » et la soustraction retournée), « J'ajoute comme
// des entiers » est la seule phrase de méthode (une AUTORISATION d'oublier la
// virgule pendant le calcul, pas une règle). Même squelette sur les deux
// pages, mêmes nombres (la paire sacrifiée et sa soustraction liée).
const FICHE_SOMMES = {
    pages: [
        {
            titre: 'Fais pareil avec tes nombres',
            lignes: [
                '2,7 + 1,4 ?',
                '2,7 c\'est **27 dixièmes**. 1,4 c\'est **14 dixièmes**.',
                'J\'ajoute comme des entiers : **27 + 14 = 41**.',
                '41 dixièmes, ça s\'écrit **4,1**.',
            ],
        },
        {
            titre: 'Pour enlever, pareil',
            lignes: [
                '4,1 − 1,4 ?',
                '4,1 c\'est **41 dixièmes**. 1,4 c\'est **14 dixièmes**.',
                'J\'enlève comme des entiers : **41 − 14 = 27**.',
                '27 dixièmes, ça s\'écrit **2,7**.',
            ],
        },
    ],
};

// Le défi en CENTIÈMES : même principe, et le geste propre au défi rendu
// visible (1,2 c'est 1,20 : c'est LA marche de l'alignement).
const FICHE_DEFI = {
    pages: [
        {
            titre: 'Fais pareil avec tes nombres',
            lignes: [
                '3,45 + 1,2 ?',
                '3,45 c\'est **345 centièmes**. 1,2 c\'est 1,20 : **120 centièmes**.',
                'J\'ajoute comme des entiers : **345 + 120 = 465**.',
                '465 centièmes, ça s\'écrit **4,65**.',
            ],
        },
    ],
};

const CP_1044 = {
    sommes_texte_trou_saisie: FICHE_SOMMES,
    sommes_qcm: FICHE_SOMMES,
    // verif_inverse_saisie : volontairement absent (pur travail résiduel).
    defi_alignement_saisie: FICHE_DEFI,
};

export default CP_1044;
